<template>
  <div class="unit-card__outer">
    <div class="unit-card">
      <div class="unit-card__top">
        <div class="unit-card__head">
          <div class="unit-card__code">{{unit.code}}</div>
          <div class="unit-card__credit" v-if="unit.credits">{{unit.credits}} credit points</div>
        </div>
        <button type="button" class="unit-card__title-btn" v-on:click="clickUnitTitle">{{unit.name}}</button>
      </div>
      <div class="unit-card__actions">
        <div v-if="canComplete">
          <div v-if="duplicate" class="duplicate" :id="`tooltip-duplicate-card-${unit.code}`">
            Duplicate
          </div>
          <!-- <template v-else> -->
          <button type="button" :class="['unit-card__complete-button', completed ? 'complete' : '']" v-on:click="toggleUnitComplete()"
            :id="`tooltip-completed-card-${unit.code}`">
            <i :class="completed ? 'fas' : 'far'" class="fa-check-circle"></i>
            <span v-if="!completed">Mark <template v-if="!isReviewer">unit as</template> complete</span>
            <span v-if="completed">Unit completed</span>
          </button>
          <!-- </template> -->
        </div>
        <div v-if="isReviewer" class="unit-card__status-version-badges">
          <div v-if="isDiscontinued || isArchived" class="badge badge-danger" :class="isDiscontinued ? '' : ''">{{ statusLabel(unit.masterStatus) }}</div>
          <div v-else class="badge" :class="unit.status != 'Active' ? 'badge-primary' : 'badge-success'">{{ statusLabel(unit.status) }}</div>
          <div class="badge badge-secondary">v{{ unit.courseLoopVersionNumber || unit.version }}</div>
        </div>

        <!--<button type="button" class="btn-icon unit-card__delete" v-if="canDelete" @click="remove"><i class="far fa-trash-alt"></i></button>-->
      </div>

      <UnitCardDiscontinued :item="this.realItem"/>
      <UnitCardPreReq v-if="!isArchived" :item="this.realItem" :firstLevelTitle="this.firstLevelTitle" :code="unit.code" />
      <UnitCardExclusions v-if="!isArchived" :item="this.realItem" :firstLevelTitle="this.firstLevelTitle" :code="unit.code" />
      <UnitCardMissingOffering v-if="!isArchived" :item="this.realItem" :firstLevelTitle="this.firstLevelTitle" :code="unit.code" />
      <UnitCardErrorL100 v-if="isLevel100 && !isArchived" :code="unit.code" />
    </div>

    <b-tooltip v-if="duplicate" :target="`tooltip-duplicate-card-${unit.code}`" triggers="hover focus" placement="right">
      {{ __("label:duplicate tooltip") }}
    </b-tooltip>
    <b-tooltip :target="`tooltip-completed-card-${unit.code}`" triggers="hover" placement="right">
      <span v-html="__('label:completed tooltip')"></span>
    </b-tooltip>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import inputBuilder from 'common/helpers/input-builder.js'
import UnitCardPreReq from './UnitCardPreReq.vue'
import UnitCardExclusions from './UnitCardExclusions.vue'
import UnitCardMissingOffering from './UnitCardMissingOffering.vue'
import UnitCardDiscontinued from './UnitCardDiscontinued.vue'
import UnitCardErrorL100 from './UnitCardErrorL100.vue'
import SlideOutUnitDetailsView from './slide-out-tree-view/SlideOutUnitDetailsView.vue'
import StudentPreferences from 'client/js/models/student-preferences.js'

export default {
  components: { UnitCardPreReq, UnitCardErrorL100, UnitCardMissingOffering, UnitCardExclusions, UnitCardDiscontinued },
  props: {
    unit: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: false
    },
    canComplete: {
      type: Boolean,
      required: false,
      default: true
    },
    firstLevelTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dupTip: '',
      slideOutComponent: SlideOutUnitDetailsView
    }
  },
  computed: {
    ...mapGetters({
      course: 'courses/getSelectedCourse',

      selectedPreferences: 'preferences/getSelectedStudyPreferences',

      completedUnits: 'units/getCompletedUnits',
      items: 'units/getSelectedCurriculumItems',
      generalElectiveLevel100Alert: 'units/getGeneralElectiveLevel100Alert',
      getIsLevel100: 'units/isLevel100',
      isReviewer: 'global/isReviewer'
    }),
    completed() {
      return this.completedUnits.includes(this.unit.code)
    },
    duplicate() {
      const result = this.items.filter((item) => item.id === this.unit.id)
      return result && result.length > 1
    },
    exclusionClash() {
      console.log('exclusionClash', this.unit.id, this.unit.unit.requisites)
      // const result = this.items.filter((item) => item.id === this.unit.id)
      // return result && result.length > 1
    },
    realItem() {
      return this.items.find((item) => item.id === this.unit.id)
    },
    isLevel100() {
      const a = this.generalElectiveLevel100Alert
      const b = this.getIsLevel100(this.realItem.id, this.realItem.verticalGrouping)
      return a && b
    },
    isDiscontinued() {
      // console.log('isDiscontinued', this.unit)
      return this.unit?.masterStatus == 'Discontinued'
    },
    isArchived() {
      // console.log('isArchived', this.unit)
      return this.unit?.masterStatus == 'Archived'
    }
  },
  methods: {
    // __:i18n,
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    }),
    ...mapActions({
      removeItem: 'units/removeCurriculumItem',
      updateUnitCompletion: 'units/updateUnitCompletion'
    }),
    toggleUnitComplete() {
      this.updateUnitCompletion({
        id: this.unit.id,
        code: this.unit.code,
        completed: !this.completed
      })
    },
    clickUnitTitle() {
      this.openSlideOut({ component: this.slideOutComponent, componentProperties: this.realItem })
    },
    statusLabel(id) {
      return this.__(`label:status ${id.toLowerCase()}`)
    },
    remove() {
      this.removeItem({
        relationship: this.unit,
        location: this.location,
        recursive: true
      })
    }
  }
}
</script>
